import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "not-found section" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center mt-5" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  class: "error-content",
  "data-aos": "fade-up",
  "data-aos-delay": "200"
}
const _hoisted_7 = { class: "error-actions mb-5" }
const _hoisted_8 = { class: "quick-links-card" }
const _hoisted_9 = { class: "row g-4" }
const _hoisted_10 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "300"
}
const _hoisted_11 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_12 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "500"
}
const _hoisted_13 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "300"
}
const _hoisted_14 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "400"
}
const _hoisted_15 = {
  class: "col-md-4",
  "data-aos": "fade-up",
  "data-aos-delay": "500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"row align-items-center justify-content-center\"><div class=\"col-lg-6 text-center\" data-aos=\"fade-up\" data-aos-delay=\"100\"><div class=\"error-code-wrapper mb-4\"><h1 class=\"error-code\">404</h1><div class=\"error-code-decoration\"></div></div><h2 class=\"error-title mb-3\">Page Not Found</h2><p class=\"error-description mb-4\"> Oops! The page you&#39;re looking for seems to have wandered off into the digital void. Don&#39;t worry, we&#39;ll help you find your way back. </p></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "btn btn-primary btn-lg me-3"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "bi bi-house-door me-2" }, null, -1),
                    _createTextVNode(" Go to Homepage ")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                  class: "btn btn-outline-primary btn-lg"
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "bi bi-arrow-left me-2" }, null, -1),
                  _createTextVNode(" Go Back ")
                ]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "quick-links-title mb-4" }, [
                  _createElementVNode("i", { class: "bi bi-compass me-2" }),
                  _createTextVNode(" Quick Links ")
                ], -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: "/about",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-info-circle" })
                        ], -1),
                        _createElementVNode("h4", null, "About Us", -1),
                        _createElementVNode("p", null, "Learn more about MatrixHub", -1)
                      ])),
                      _: 1,
                      __: [3]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: "/services",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-briefcase" })
                        ], -1),
                        _createElementVNode("h4", null, "Our Services", -1),
                        _createElementVNode("p", null, "Explore what we offer", -1)
                      ])),
                      _: 1,
                      __: [4]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: "/products",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-box-seam" })
                        ], -1),
                        _createElementVNode("h4", null, "Our Products", -1),
                        _createElementVNode("p", null, "Discover our solutions", -1)
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: "/team",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-people" })
                        ], -1),
                        _createElementVNode("h4", null, "Our Team", -1),
                        _createElementVNode("p", null, "Meet the experts", -1)
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/contact",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-envelope" })
                        ], -1),
                        _createElementVNode("h4", null, "Contact Us", -1),
                        _createElementVNode("p", null, "Get in touch", -1)
                      ])),
                      _: 1,
                      __: [7]
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      to: "/privacy-policy-page",
                      class: "quick-link-item"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createElementVNode("div", { class: "quick-link-icon" }, [
                          _createElementVNode("i", { class: "bi bi-shield-check" })
                        ], -1),
                        _createElementVNode("h4", null, "Privacy Policy", -1),
                        _createElementVNode("p", null, "Read our policy", -1)
                      ])),
                      _: 1,
                      __: [8]
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}